import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { PaginationClientSideModule } from "src/app/app/_component/pagination-client-side/pagination-client-side.module";
import { SearchBarModule } from "src/app/app/_component/search-bar/search-bar.module";
import { SelectWithImagesModule } from "src/app/app/_component/select-with-images/select-with-images.module";
import { HeaderModule } from "src/app/_component/header/header.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { SpaceListModule } from "../../_component/_space/space-list/space-list.module";
import { ListHeaderComponentModule } from "../../_component/_structural/list-header/list-header.module";
import { MobileFilterComponentModule } from "../../_component/_structural/mobile-filter/mobile-filter.module";
import { BookingViewModule } from "../booking-view/booking-view.module";
import { BreadcrumbComponentModule } from "./../../_component/breadcrumb/breadcrumb.module";
import { RoomFilterModalComponentModule } from "./room-filter-modal/room-filter-modal.module";
import { RoomPageRoutingModule } from "./room-routing.module";
import { RoomPage } from "./room.page";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RoomPageRoutingModule,
    HeaderModule,
    TranslateModule,
    SearchBarModule,
    PaginationClientSideModule,
    TranslateModule,
    SelectWithImagesModule,
    SharedDirectivesModule,
    LoadingStiModule,
    BookingViewModule,
    BreadcrumbComponentModule,
    MobileFilterComponentModule,
    RoomFilterModalComponentModule,
    ListHeaderComponentModule,
    SpaceListModule
  ],
  declarations: [RoomPage],
})
export class RoomPageModule {}
